import { Button, Modal, TextInput } from "flowbite-react";
import React, { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import { CategoryCustom } from "../../Models/CategoryCustom";
import CommonApi from "../../Api/CommonApi";

export default function AddCategoryModal({
  show,
  setShow,
  getCategories,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  getCategories: () => Promise<void> | undefined;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const initialFormState: CategoryCustom = {
    number: 0,
    name: "",
    subCategories: [],
    count: 0,
  };

  const [formData, setFormData] = useState<CategoryCustom>(initialFormState);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "number" ? parseInt(value) || 0 : value,
    }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    setButtonDisabled(true);
    e.preventDefault();
    try {
      setIsLoading(true);
      const payload: CategoryCustom = {
        ...formData,
        subCategories: formData.subCategories ?? [],
      };
      return CommonApi.addUpdateCategory(payload)
        .then((res) => {
          if (res.data.success) {
            toast.success("Category added successfully");
            setIsLoading(false);
            setButtonDisabled(false);
            getCategories();
            setShow(false);
            setFormData(initialFormState);
          } else {
            toast.error(res.data.message);
            setIsLoading(false);
            setButtonDisabled(false);
          }
        })
        .catch((err) => {
          toast.error("Error: " + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  function onCloseModal() {
    setShow(false);
    setFormData(initialFormState);
  }

  return (
    <Modal show={show} size="md" onClose={onCloseModal} popup>
      <Modal.Header>Add Category</Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <form onSubmit={onSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Category Number
                </label>
                <TextInput
                  id="number"
                  name="number"
                  type="number"
                  placeholder="Enter category number..."
                  onChange={handleChangeInput}
                  value={formData.number || ""}
                  sizing="md"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Category Name
                </label>
                <TextInput
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter category name..."
                  onChange={handleChangeInput}
                  value={formData.name ?? ""}
                  sizing="md"
                  required
                />
              </div>
            </div>
            <div className="flex justify-end pt-4 space-x-2">
              <Button
                disabled={buttonDisabled}
                type="submit"
                className="buttonMain"
              >
                {isLoading ? <Loader /> : "Save"}
              </Button>
              <Button
                color="gray"
                onClick={onCloseModal}
                disabled={buttonDisabled}
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}
